var map = {
	"./bg1.png": "1ebe",
	"./bg2.jpg": "a31a",
	"./mario.png": "71a5",
	"./testroom.png": "c2ef",
	"./testroom2.png": "7b7a",
	"./testroom3.png": "5707",
	"./tree.png": "3811"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "24a3";